export const errorTypes = {
  conditionIncomplete: 'conditionIncomplete',
}

export const booleanFields = ['has_discounts', 'has_gifts']
